import { AnchorProvider, Idl, Program, setProvider, workspace } from "@project-serum/anchor";
import { AnchorWallet, useAnchorWallet } from "@solana/wallet-adapter-react";
import { Connection, Keypair } from "@solana/web3.js";
import MockWallet from "./MockWallet";
import { useEffect, useState, createContext } from "react";
import idl from "../tweeter_dapp.json";
import { ReactNode } from "react";
import { TweeterDapp } from "../types/tweeter_dapp";

interface WorkSpace {
  program?:Program<Idl> | undefined,
  connection?: Connection | undefined,
  wallet?: AnchorWallet

}
export const ConnectionContext = createContext({});

const ConnectionProvider = ({ children }: { children: ReactNode }) => {
  const wallet = useAnchorWallet() || MockWallet;
  // const network = "http://localhost:8899";
  const network = "https://api.devnet.solana.com";

  const  connection  = new Connection(network, "processed");
  const [workSpace, setWorkSpace] = useState<WorkSpace>(
  {});

  
  useEffect(() => {
    (async () => {
      if(!wallet) {
        return;
      }
      const provider = new AnchorProvider(connection, wallet, {preflightCommitment: "processed"});
      setProvider(provider);

      const programId = idl.metadata.address;
      const program = new Program(idl as Idl, programId, provider);
      
      setWorkSpace({
        program,
        wallet,
        connection
      })
    })();
  },[wallet])
  // if(!workSpace) return;
  const value = {workSpace};
  return(
    <ConnectionContext.Provider value={value}>{children}</ConnectionContext.Provider>
  )
};

export default ConnectionProvider;